module.exports = __webpack_public_path__ + "static/media/ketan.9438ed6b.png";